/**
 * Production environment.
 *
 * Angular swaps `environment.ts` for this file on production builds via the
 * `fileReplacements` entry in angular.json. Keep the shape identical to
 * `environment.ts`.
 */
export const environment = {
  production: true,
  apiBaseUrl: 'https://api.iotzen.app',
};
